import React, { useEffect } from 'react';
import { useHits } from 'react-instantsearch';
import { initWishlist } from '../../snippets/customer.wishlist';
import CustomPortal from '../CustomPortal';
import { ProductCard } from '@jbhi-fi/components/src/ProductCard';
import { AlgoliaHitTransformer } from '@jbhi-fi/components/src/Algolia/transformers/AlgoliaHitTransformer';
import { useProductActionsContext } from '@jbhi-fi/components/src/context/ProductActionsProvider';
import { useProductCompare } from '@jbhi-fi/components/src/ProductCompare';
import { useCustomerContext } from '@jbhi-fi/components/src/context/CustomerContextProvider';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';
import { connectorWrapper } from '../search/algoliaConnectors';

//PNP-1873 - selectors have been passed from PageFlyContainer.js
const Hits = ({ hits, skuNodes }) => {
  const { onAddToCart, productCartPropsOverrides = {} } = useProductActionsContext();
  const { isAddedToCompare, compareHandleClick, shouldShowCompare } = useProductCompare(false);
  const { isLoggedIn, handleUpdateWishlist, getIsInWishlist } = useCustomerContext();

  useEffect(() => {
    const results = hits.map(hit => hit.google_tag_manager);
    if (
      window.gtm.products &&
      results &&
      results[0] &&
      !window.gtm.products.some(p => Number(p.id) === Number(results[0].id))
    ) {
      window.gtm.products = [...window.gtm.products, results[0]];
    } else {
      window.gtm.products = results;
    }
    //PNP-1873 - Wishlist is initalised upon rendering
    initWishlist();
  }, [hits]);
  //PNP-1873 - hits are returned and passed through CustomPortal to FamilyProductCard.js to be rendered outside of parent container.
  return (
    <>
      {hits.map((hit, i) => {
        const node = skuNodes.find(
          node => node.dataset.pageflySku === hit.sku || (hit.skus && hit.skus.includes(node.dataset.pageflySku))
        );
        return (
          <CustomPortal node={node} key={i}>
            <ProductCard
              {...AlgoliaHitTransformer.toProductCardProps(hit, {
                trackingDescriptor: {
                  page: 'pageFly',
                  group: 'pageFlyProducts',
                  currency: getStoreCurrency(),
                  ecommerceExtraProps: {
                    list: 'pagefly',
                    position: i + 1,
                  },
                },
              })}
              {...productCartPropsOverrides}
              actionButtonType="primary"
              variant="fullWidth"
              onAddToCart={
                onAddToCart
                  ? (e, _sku, variantId, eventData) => onAddToCart(e, hit, variantId, eventData?.trackingDescriptor)
                  : undefined
              }
              getIsCompared={isAddedToCompare}
              onCompare={compareHandleClick}
              getShouldShowCompare={shouldShowCompare}
              isLoggedIn={isLoggedIn}
              onUpdateWishlist={handleUpdateWishlist}
              getIsInWishlist={getIsInWishlist}
            />
          </CustomPortal>
        );
      })}
    </>
  );
};

export default connectorWrapper(useHits, Hits);
